module.exports = __webpack_public_path__ + "img/10_defrost_(white).22b9be9a.svg";